import Header,{HeaderPhone} from "./components/Header";
import Home from "./components/Home";
import Work from "./components/Work";
import TimeLine from "./components/TimeLine";
import Services from "./components/Services";
import Testimonial from "./components/Testimonial";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Skills from "./components/Skills";
import { Toaster } from "react-hot-toast";
import { useState,useEffect } from "react";
import Cursor from "./components/Cursor";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [ratio, setRatio] = useState(window.innerWidth/window.innerHeight);
   useEffect(() => {
    const resizeRatio = ()=>{
        setRatio(window.innerWidth/window.innerHeight);
    };
    window.addEventListener("resize", resizeRatio);
    return ()=>{
      window.removeEventListener('resize', resizeRatio);
    };
  },[ratio]);
  return ratio<2 ? (
    <>
    <Cursor/>
    <HeaderPhone menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
    <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
    <Home ratio={ratio}/>
    {/* <Skills/> */}
    <Work/>
    <TimeLine/>
    <Services/>
    <Testimonial/>
    <Contact/>
    <Footer/>
    <Toaster/>
    </>
  ): <em id="customMessage">Please Change the ratio to view!</em>
}

export default App;